module.exports = __webpack_public_path__ + "static/media/retirement-object-0-0-1.1eca3830.svg";